// @flow

import React, { type Node } from 'react';
import cx from 'classnames';
import LinkButton from 'client/components/button/linkButton';
import Translate from 'client/components/translate';
import { CSSTransition } from 'react-transition-group';
import 'client/styles/notification.scss';

type NotificationContentType = {
  header: string,
  text: string,
  using: Object,
};

type Props = {
  theme: 'green' | 'orange' | 'red' | 'info',
  border: boolean,
  content: NotificationContentType | null,
  children: Node,
  actionable: {
    label: string,
    to: string,
    onClick?: Function,
  } | null,
  borderPosition: string,
  className: string,
};

function renderContent(content: NotificationContentType) {
  return (
    <div className="flex-child-expand" style={{ lineHeight: 1.2 }}>
      <div className="header bold pad-right" style={{ display: 'inline-block' }}>
        <Translate path={content.header} using={content.using} />
      </div>
      <div className="content pad-right" style={{ display: 'inline-block' }}>
        <Translate path={content.text} using={content.using} />
      </div>
    </div>
  );
}

export default class Notification extends React.PureComponent<Props> {
  static defaultProps = {
    border: false,
    content: null,
    children: null,
    actionable: null,
    borderPosition: 'bottom',
    className: '',
  };

  render() {
    const { theme, border, borderPosition, actionable, content, className } = this.props;
    const rowClasses = 'flex-row collapse center-col';
    const hasChildren = !!this.props.children;

    return (
      <CSSTransition classNames="slidedown" in appear timeout={{ exit: 300, enter: 500 }}>
        <div className={`notification-parent ${className}`}>
          <div
            className={cx('notification-container', theme, {
              [`border-${borderPosition}`]: border,
            })}>
            {hasChildren ? (
              <div className={rowClasses}>{this.props.children}</div>
            ) : (
              content && (
                <div className={rowClasses}>
                  <div className="flex-child-expand">{renderContent(content)}</div>
                  {actionable && (
                    <div className="no-padding text-right">
                      <LinkButton
                        theme={theme}
                        className="rounded sm no-margin"
                        to={actionable.to}
                        onClick={actionable.onClick || null}>
                        <Translate path={actionable.label} />
                      </LinkButton>
                    </div>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </CSSTransition>
    );
  }
}
